"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentService = void 0;
const win_1 = require("@wix/cashier-common/dist/src/utils/win");
const apiRoutes_1 = require("../../utils/apiRoutes");
const Base_1 = require("../Base");
class PaymentService extends Base_1.BaseService {
    chargeOrder(orderId, data, options) {
        const { fullInfo = true } = options || {};
        return this.request({
            url: (0, apiRoutes_1.orderChargesUrl)(orderId),
            method: 'post',
            data,
        }).then((response) => (fullInfo ? response.charge : PaymentService.parseResponseToken(response.responseToken)));
    }
    getCharge(chargeId) {
        return this.request({
            url: (0, apiRoutes_1.chargeUrl)(chargeId),
            method: 'get',
        }).then(({ charge }) => charge);
    }
    getCharges(orderId) {
        return this.request({
            url: (0, apiRoutes_1.orderChargesUrl)(orderId),
            method: 'get',
        }).then(({ charges }) => charges);
    }
    createPayment(data) {
        return this.request({
            url: (0, apiRoutes_1.paymentDetailsUrl)(),
            method: 'post',
            data,
        });
    }
}
exports.PaymentService = PaymentService;
PaymentService.parseResponseToken = (responseToken) => {
    try {
        return JSON.parse(win_1.win.atob(responseToken));
    }
    catch (error) {
        throw new Error(`Failed to parse response token: ${error.message}`);
    }
};
//# sourceMappingURL=index.js.map